import prepareTranslate from '@/helpers/dictionary';
import agentMutations from '@/api/mutitations/agent';
import { useNavigate } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import routes from '@/routes';
import { routeWithParams } from '@/helpers/route';
import { notifications } from '@mantine/notifications';
import { useForm } from '@mantine/form';
import PageTemplate from '@/components/PageTemplate';
import validations from '@/helpers/validation/index';
import EditAgentDetails from '@/components/EditAgentDetails';

const AgentCreate = () => {
  const t = prepareTranslate();
  const navigate = useNavigate();
  const [loading, { open, close }] = useDisclosure(false);

  const { useCreateAgent } = agentMutations;
  const { mutateAsync } = useCreateAgent();

  const form = useForm({
    initialValues: {
      personalDetails: {
        children: [],
      },
    },
    validate: {
      status: (value) => validations.required(value),
      agentType: (value) => validations.required(value),
      employeeType: (value) => validations.required(value),
      personalDetails: {
        firstName: (value) => validations.required(value),
        lastName: (value) => validations.required(value),
        uid: (value) => validations.required(value) || validations.uid(value),
        gender: (value) => validations.required(value),
        dob: (value) => validations.required(value),
        website: (value) => value && validations.required(value),
        spousePhone: (value) => value && validations.phone(value),
        spouseEmail: (value) => value && validations.email(value),
        email: (value) => value && validations.email(value),
        phone: (value) => value && validations.phone(value),
        extraPhone: (value) => value && validations.phone(value),
        homePhone: (value) => value && validations.phone(value),
        children: {
          childrenName: (value) => validations.required(value),
        },
      },
    },
  });

  const handleAgentCreateClick = async (agentValues) => {
    try {
      open();

      const newAgent = await mutateAsync(agentValues);

      if (!newAgent) {
        close();
        return { success: false };
      }

      const { id } = newAgent;
      navigate(routeWithParams(routes.agentView.path, { id, tab: 'details' }));

      close();
      return { success: true };
    } catch (error) {
      onError?.();
      close();
      return { success: false };
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const onError = () => {
    open();
    notifications.show({
      title: t('pages.agentcreate.notification.validtion.title'),
      message: t('pages.agentcreate.notification.validtion.message'),
    });
    close();
  };

  return (
    <>

      <PageTemplate
        title={t('pages.agentcreate.title')}
        withBackButton
      >
        <EditAgentDetails
        form={form}
        handleAgentUpdateOrSaveClick={handleAgentCreateClick}
        loading={loading}
        handleBackClick={handleBackClick}
        onError={onError}/>

     </PageTemplate>
    </>
  );
};

export default AgentCreate;
